import React from "react";
import "./index.css";
import classNames from "classnames";
import { getLink } from '../../../utils';


const MenuItem = (props) => {
  const {
    label,
    value,
    href,
    target,
    active = false,
    onClick,
  } = props;
  const handleClick = () => {
    onClick && onClick(value);
  };

  return (
    <div className={classNames("menu-item", {
      "active": active,
    })}
      key={value} onClick={handleClick} >
      {href ? <a href={getLink(href)} target={target}> {label} </a> : <div>{label}</div>}
    </div>
  );
}

const Menu = ({ onActive,  activeKey, menus = [] , reset = false  }) => {
  const handleActive = (activeKey) => {
    onActive && onActive(activeKey);
  };

  const setActive = (item) => {
    if(reset) return false;
    return item.value === activeKey;
  }

  return (
    <div className="bx-header-menu aia-bx-mobile-hide">
      {menus.map((item, index) => (
        <MenuItem key={index} {...item}
        onClick={handleActive}
        active={setActive(item)}
        />
      ))}
    </div>

  );
}

export default Menu;
